import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Button } from '@shared/ui/button';

export function NotFoundPage(): React.ReactElement {
  const { t } = useTranslation('common');
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="space-y-6 text-center">
        <h1 className="text-6xl font-bold text-destructive">404</h1>
        <h2 className="text-3xl font-semibold">{t('common.pageNotFound')}</h2>
        <p className="text-lg text-muted-foreground">
          {t('common.notFound')}
        </p>
        <Button onClick={() => navigate('/')}>
          {t('common.back')}
        </Button>
      </div>
    </div>
  );
}
